var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcEmailReceived = function SvgIcEmailReceived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9FB",
    stroke: "#E4E5EB",
    rx: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2F3641",
    points: "1.607 3.646 .9 4.354 3.3 6.754 7.148 1.807 6.359 1.193 3.207 5.246",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 1,
    fill: "#0A182E"
  }))));
};
export default SvgIcEmailReceived;